import './productsRating.css';
import angular from 'angular';
import uirouter from 'angular-ui-router';

import brand from '../../service/brand';
import user from '../../service/user';
import review from '../../service/review';
import product from '../../service/product';


import menuLayout from '../../directive/menu-layout';
import dateFormat from '../../directive/date-format';
import starRating from '../../directive/star-rating';

import routing from './productsRating.routes';
import ProductsRatingController from './productsRating.controller';

export default angular.module('page.productsRating', [
		uirouter,

		brand,
		user,
		review,
		product,

		menuLayout,
		dateFormat,
		starRating,
		'ui.bootstrap.datetimepicker',
		'angularUtils.directives.dirPagination',
	])
	.config(routing)
	.controller('ProductsRatingController', ProductsRatingController)
	.name;



// WEBPACK FOOTER //
// ./src/page/productsRating/index.js